import {
    useDispatch,
    useSelector
} from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ButtonBase,
    Tooltip
} from '@mui/material';
import { SET_THEME_MODE } from '../store/actions';
import {
    IconMoon,
    IconSun
} from '@tabler/icons';

const ThemeModeToggle = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const isDark = useSelector((state) => state.customization.navType) === 'dark';

    const label = isDark ? 'Perjungti į šviesią temą' : 'Perjungti į tamsią temą';

    const handleToggle = () => {
        dispatch({ type: SET_THEME_MODE, navType: isDark ? 'light' : 'dark' });
    };

    return (
        <Box
            sx={{
                ml: 2,
                mr: {
                    xs: 1,
                    md: 1.5
                }
            }}
        >
            <Tooltip
                title={label}
            >
                <ButtonBase
                    aria-label={label}
                    onClick={handleToggle}
                    sx={{
                        borderRadius: '10px'
                    }}
                >
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'background-color .15s ease, color .15s ease',
                            bgColor: 'secondary.light',
                            color: 'secondary.dark',
                            '&:hover': {
                                bgcolor: 'secondary.dark',
                                color: 'secondary.light'
                            }
                        }}
                    >
                        {isDark ? <IconSun stroke={1.6} size="1.25rem" /> : <IconMoon stroke={1.6} size="1.25rem" />}
                    </Avatar>
                </ButtonBase>
            </Tooltip>
        </Box>
    );
};

export default ThemeModeToggle;